import { Contract } from 'cpfr-common';
import { ComboboxDefaultState } from '@cp-shared-19/frontend-ui';
import { Combobox, FormField } from '@vwfs-bronson/bronson-react';
import { LicensePlate } from 'components/license-plate/LicensePlate';
import { useField } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { ComboboxOption } from 'types/bronson-react';

export const ContractSelect: React.FC<{
    testId: string;
    name: string;
    label: string;
    options: ComboboxOption[];
    visible: boolean;
    defaultState?: ComboboxDefaultState;
    contracts?: Contract[];
}> = ({ testId, label, name, options, visible, defaultState, contracts }) => {
    const [field, , helpers] = useField(name);
    const [selectedItem, setSelectedItem] = useState<{ value: ComboboxOption[] }>({
        value: [
            {
                value: options.find((o) => o.key === field.value)?.value || field.value,
                key: field.value,
            },
        ],
    });
    useEffect(() => {
        if (field.value === 'all') {
            setSelectedItem({
                value: [{ key: 'all', value: 'Tous' }],
            });
        }
    }, [field.value]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = useCallback((values: any) => {
        setSelectedItem({ value: [values[0]] });
        helpers.setValue(values[0]?.key);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const comboDefaultState = defaultState
        ? defaultState
        : {
              value: [
                  {
                      value: options.find((o) => o.key === field.value)?.value || field.value,
                      key: field.value,
                  },
              ],
          };

    if (!visible) return null;

    const generateOptions = () => {
        return options.map((filter) => {
            const contract = contracts?.find((c) => c.contractNumber.includes(filter.value as string)); // TODO contract ID in documents are different then in contract details
            return {
                key: filter.key,
                value: {
                    textValue: filter.value as string,
                    content: contract ? (
                        <table>
                            <tbody>
                                <tr>
                                    <LicensePlate registrationNumber={contract?.licensePlate} />
                                </tr>
                                <tr>
                                    <td>
                                        <span>{contract?.carModel}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span>
                                            <strong>{`${contract?.productTypeFR} ${filter.value}`}</strong>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    ) : (
                        filter.value
                    ),
                },
            };
        });
    };

    return (
        <FormField type="select" testId={testId} id={'document-type'} labelText={label} noFloatingLabel>
            <Combobox
                name={name}
                testId={`${testId}-combo`}
                onChange={onChange}
                value={selectedItem.value}
                defaultState={comboDefaultState}
                className="c-form-field--no-floating"
                options={generateOptions()}
            ></Combobox>
        </FormField>
    );
};
